// DS: i6.28
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const PlayVideo: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM16 12L9 16V8L16 12Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
PlayVideo.displayName = 'PlayVideo';

export default PlayVideo;
